import CenteredView from "./CenteredView";

export default CenteredView